import axiosInstance from '../shared/axiosInstance';
import { serviceConfig } from '../../config';
import { RemoveVinFromDealershipForOwnerReqV1 } from './types';

async function removeVinFromDealershipForOwner(
  queryObject: RemoveVinFromDealershipForOwnerReqV1 | undefined,
): Promise<void> {
  if (queryObject === undefined) {
    throw new Error('Undefinedvalue');
  }
  const url = `${serviceConfig.endpoints.legacy.root}${serviceConfig.endpoints.legacy.dealerships}/removevinfromdealershipforowner?dealershipId=${queryObject.dealershipId}&ownerUserid=${queryObject.ownerUserid}&vin=${queryObject.vin}`;

  console.log('Complete url');
  console.log(url);
  let result = null;

  try {
    const response = await axiosInstance.delete(url);
    result = response.data;
    console.log(result);
  } catch (err) {
    throw new Error('Error adding user to dealership');
  }

  return result;
}

export default removeVinFromDealershipForOwner;
